import { memo } from "react";
import { BzTabs, BzTab } from "../../../components";
import { FACILITY_NUM, ORDER_TYPES, SCRIP_INSTRUMENTS, WATCHLIST_GRID_INDEX } from "../../../utils/global_variables";
import { getScripOrderInfo } from "../../../redux/actions/orders";
import { useDispatch, useSelector } from "react-redux";
import { updateBasketClick } from "../../../redux/actions/orderCart";

const PlaceOrderTabs = ({ arrPlaceOrderInfo, activeTabKey, setActiveTabKey, setMultiScripOrderActiveTabKey, scripOrderInfo }) => {
    const dispatch = useDispatch();
    const objCFT = useSelector(state => state?.auth?.objCFT);
    const handleOrderEntryTab = (eachTab) => {
        setActiveTabKey(eachTab.tabKey);
        if (eachTab?.tabKey === ORDER_TYPES.SINGLE_SCRIP) {
            if (scripOrderInfo[WATCHLIST_GRID_INDEX.NSPREAD] === 1) {
                dispatch(getScripOrderInfo({ isBuySell: 'BUY', activeExchangeId: scripOrderInfo[WATCHLIST_GRID_INDEX.EXCHANGE], scripData: [] }));
            }
        }
        else if (eachTab?.tabKey === ORDER_TYPES.MULTI_SCRIP){
            if(scripOrderInfo[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES){
                dispatch(updateBasketClick(true));
                setMultiScripOrderActiveTabKey(ORDER_TYPES.BASKET);
            }
            else if (scripOrderInfo?.[WATCHLIST_GRID_INDEX.NSPREAD] !== 1 && (scripOrderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT]?.startsWith('FUT') || scripOrderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT]?.startsWith('OPT')) && objCFT.MULTILEG === FACILITY_NUM.ON){
                setMultiScripOrderActiveTabKey(ORDER_TYPES.MULTI_LEG)
            }
        }
    };
    return (
        <div className=''>
            <BzTabs className='nav nav-tabs horizontal-scroll-wrap'>
                {arrPlaceOrderInfo?.map((eachTab) => (
                    //Maaz A : 17-11-2023 : Client Facility Template - Added for MultiLeg and Spread - Start
                    eachTab &&
                    <BzTab className='nav-link text-capitalize' key={eachTab.tabKey} tabKey={eachTab.scrip} isActive={eachTab.tabKey === activeTabKey} onClick={handleOrderEntryTab.bind(this, eachTab)}>{eachTab.scrip}</BzTab> //ManasaB : 08-10-2024 : To restrict rendering of Basket without clicking on multiscrip
                    //Maaz A : 17-11-2023 : Client Facility Template - Added for MultiLeg and Spread - End
                ))}
            </BzTabs>
        </div>
    );
};

export default memo(PlaceOrderTabs);